import { i18n } from '@lingui/core';
import { activateLang } from '../locales/loadTranslations.js';
import { messages as fi } from '../locales/fi/messages_fi.js';
import { messages as en } from '../locales/en/messages_en.js';
import { messages as nb } from '../locales/nb/messages_nb.js';
import { messages as da } from '../locales/da/messages_da.js';
import { messages as sv } from '../locales/sv/messages_sv.js';

const Spinner = () => {
    activateLang({ fi, en, nb, da, sv });
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            focusable="false"
            className="tjt-loading-spinner"
        >
            <title>
                {i18n._({
                    id: 'svg.Spinner.title',
                    comment: 'Screen reader text for a loading spinner',
                    message: 'Loading spinner',
                })}
            </title>
            <circle cx="12.5" cy="12" r="10.5" stroke="#DEE9FA" strokeWidth="3" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5 12C21.5 7.53831 18.2534 3.83491 13.9937 3.12339C13.1766 2.9869 12.5 2.32843 12.5 1.5C12.5 0.671573 13.1749 -0.00983451 13.997 0.0924695C19.9179 0.829293 24.5 5.87955 24.5 12C24.5 12.7561 24.4299 13.4968 24.2956 14.2157C24.1434 15.0301 23.2888 15.4639 22.5 15.2108C21.7112 14.9577 21.2903 14.1126 21.4081 13.2926C21.4686 12.871 21.5 12.4395 21.5 12Z"
                fill="#06BEFB"
            />
        </svg>
    );
};

export default Spinner;
